module.exports = __webpack_public_path__ + "static/media/news6.03e0438d.jpg";